import React, { useState, useContext, useMemo, useEffect } from 'react';
import { makeStyles, Grid, TextField } from '@material-ui/core';

import { injectIntl } from 'react-intl';

import { FormServiceContext } from 'app/utils/contexts';

import { Formik, Form, Field } from 'formik';
import AlertMessage from 'app/components/AlertMessage';
import notification from 'app/config/notification';
import RegistrationStatus from '../../Registration/components/RegistrationStatus';
import RenderTab from './RenderTab';
import Documentation from 'app/components/Documentation';
import TableEdit from '../TableEdit';
import TableAdd from '../TableAdd';
import SaveButton from 'app/components/SaveButton';
import FinalizeButton from 'app/components/FinalizeButton';
import { useSelector } from 'react-redux';
import { SERVICES_CODES } from 'app/config/services';
import { STATUS_CODES } from 'app/config/status';

import styles from './styles';
const useStyles = makeStyles(styles);

function VehicleRegistration(props) {
    const classes = useStyles();

    const contextProps = useContext(FormServiceContext);

    const request = useSelector((state) => state.requests.details);
    const service = useSelector((state) => state.services.details);
    const internalNewRequest = useSelector((state) => state.forms.internalNewRequest);

    const isInternalNewRequest = useMemo(() => {
        return Object.keys(internalNewRequest).length > 0;
    }, [internalNewRequest]);

    const { initialValues } = props;

    const {
        onSubmit,
        onSave,
        onCancel,
        mainColor,
        hideActionBtn,
        hideActionBtnRequest,
        hideFinalizeBtn,
        canEdit,
        isInternalForm,
        loadingDocuments,
    } = contextProps;

    const viewsIdentification = 0;
    const viewsDocumentation = 1;

    const [view, setView] = useState(viewsIdentification);
    const [canPartialEdit, setCanPartialEdit] = useState(canEdit);

    useEffect(() => {
        const init = () => {
            if (isInternalNewRequest) {
                setCanPartialEdit(false);
            } else if (request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO && !isInternalForm) {
                setCanPartialEdit(true);
            }
        };
        init();
    }, [isInternalForm, isInternalNewRequest, request.cdSituacao]);

    const handleViewChange = (event, value) => {
        setView(value);
    };

    const isAdd = useMemo(() => {
        return (
            service.cdServico === SERVICES_CODES.INCLUSAO_VEICULOS ||
            service.cdServico === SERVICES_CODES.INCLUSAO_VEICULOS_SEM_CRC
        );
    }, [service.cdServico]);

    const [disableObservation] = useState(() => {
        if (!canEdit) {
            if (!request.situacao) return false; // new request
            return !(request.situacao?.boEdicaoPortalExterno || request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO);
        }
        return !canEdit;
    });

    // Correção 369177: persistência da deObservacaoExclusao
    // infelizmente neste fluxo o initialValues tá vindo undefined (motivos desconhecidos; corrigir isto tem impacto imprevisível...)
    // então por expediência vou pegar direto da request, quando neste fluxo específico.
    const [valorInicialObservacaoExclusao, setValorInicialObservacaoExclusao] = useState('');
    useEffect(() => {
        if (isInternalForm && SERVICES_CODES.EXCLUSAO_VEICULOS === service.cdServico) {
            if (request.jsonSolicitacao) {
                const jsonSolicitacao = JSON.parse(request.jsonSolicitacao);
                setValorInicialObservacaoExclusao(jsonSolicitacao.deObservacaoExclusao ?? '');
            }
        }
    }, [isInternalForm, service, request]);

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues ? initialValues : {}}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={(values) => {
                    onSubmit(values);
                }}>
                {(props) => {
                    return (
                        <Form className={classes.containerForm}>
                            <RenderTab
                                classes={classes}
                                handleViewChange={handleViewChange}
                                mainColor={mainColor}
                                view={view}
                                loadingDocuments={loadingDocuments}
                                isInternalForm={isInternalForm}
                            />

                            <AlertMessage isInternalForm={isInternalForm} />

                            <Grid container spacing={3} className={classes.containerMainData}>
                                <RegistrationStatus {...props} classes={classes} />
                            </Grid>

                            {view === viewsIdentification && (
                                <>
                                    {isAdd && <TableAdd {...props} contextProps={contextProps} />}
                                    {!isAdd && (
                                        <>
                                            <TableEdit {...props} contextProps={contextProps} />
                                            {service.cdServico === SERVICES_CODES.EXCLUSAO_VEICULOS && (
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="deObservacaoExclusao"
                                                        // defaultValue={valorInicialObservacaoExclusao}
                                                        label="Observações"
                                                        variant="filled"
                                                        margin="dense"
                                                        disabled={disableObservation}
                                                        multiline
                                                        minRows={4}
                                                        fullWidth
                                                        as={TextField}
                                                        InputLabelProps={
                                                            valorInicialObservacaoExclusao.length > 0
                                                                ? { shrink: true }
                                                                : {}
                                                        }
                                                        inputProps={{
                                                            maxLength: 4900,
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            {view === viewsDocumentation && <Documentation {...props} contextProps={contextProps} />}

                            {!hideActionBtnRequest && (
                                <SaveButton
                                    mainColor={mainColor}
                                    hideActionBtn={hideActionBtn && !canPartialEdit}
                                    isInternalForm={isInternalForm}
                                    canEdit={canPartialEdit}
                                    onCancel={onCancel}
                                    onSave={() => {
                                        props.validateForm().then((res) => {
                                            if (Object.keys(res).length <= 0) {
                                                onSave(props.values, false, isInternalForm);
                                            } else {
                                                notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                                                    toastId: 'VALIDATION',
                                                    type: 'error',
                                                });
                                            }
                                        });
                                    }}
                                />
                            )}

                            <FinalizeButton
                                mainColor={mainColor}
                                hideFinalizeBtn={hideFinalizeBtn}
                                isInternalForm={isInternalForm}
                                canEdit={canEdit}
                                onSubmit={() => {}}
                            />
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
}

export default injectIntl(VehicleRegistration);
